const awsmobile = {
  Auth: {
    // Amazon Cognito Region
    region: "us-west-2",

    // Amazon Cognito User Pool ID
    userPoolId: "us-west-2_nm1NV760t",

    // Amazon Cognito Web Client ID (26-char alphanumeric string)
    userPoolWebClientId: "1viv4kdp0t94jb6qe27e0hjb18"
  }
};

export default awsmobile;